import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import withPermissions from "../../components/WithPermissions";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
    apiCall,
    getBranches,
    getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import Select from "react-select";
class VehicleAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            branches: [],
            vehicles: [],
            customers: [],
            loading: false,
            isLoad: true,
            brands: [],
            models: [],
            selectedBrand: '',
            selectedModel: '',
            selectedCustomer: [],
            isDragActive: false,
            vehicleImagePreviews: [],
            formData: {
                brand: '',
                branch_id: '',
                customer_id: '',
                model: '',
                plate: '',
                year: '',
                km: '',
                gen: '',
                chassis_no: '',
                engine_no: '',
                package_name: '',
                engine_size: '',
                key_no: '',
                details: '',
                vehicleImages: [],
                maintenance_date: '',
                next_maintenance_date: '',
                inspection_date: '',
                next_inspection_date: '',
                gear_type: '',
            }
        }
        this.vehicleImagesInputRef = React.createRef();
    }
    async componentDidMount() {
        try {
            this.getBrands();
            this.setState({
                branches: await getBranches(),
                customers: await getCustomers(),
            });
        } catch (e) {
            throw e;
        }
    }
    getBrands = async () => {
        const response = await apiCall('business/vehicle/get-brands', 'get', null);
        const brandOptions = response.map(brand => ({
            value: brand.id,
            label: brand.name
        }));
        this.setState({ brands: brandOptions });
    }

    handleBrandChange = async (selectedOption) => {
        const brand_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                brand: brand_id,
                model: ""
            },
            selectedBrand: option,
            models: []
        }));

        if (brand_id) {
            try {
                const response = await apiCall(`business/vehicle/get-models/${brand_id}`, 'get', null);

                const modelOptions = response.map(model => ({
                    value: model.id,
                    label: model.name
                }));
                this.setState({ models: modelOptions });
            } catch (error) {
                console.error("Modelleri alırken hata oluştu:", error);
            }
        }
    }
    handleModelChange = async (selectedOption) => {
        const model_id = selectedOption.value;
        const option = {
            value: selectedOption.value,
            label: selectedOption.label
        }
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                model: model_id
            },
            selectedModel: option,
        }));
    }
    handleChange = (e) => {
        const { id, value, files } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [id]: files ? Array.from(files) : value
            }
        }));
    }
    handleCustomerChange = (selectedCustomer) => {
        const formattedSelectedOptions = {
            value: selectedCustomer.value,
            label: selectedCustomer.label
        } || {};

        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                customer_id: formattedSelectedOptions.value
            },
            selectedCustomer: formattedSelectedOptions
        }));
    };
    handleVehicleImagesSelect = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        this.setState((prev) => {
            const newFiles = [...(prev.formData.vehicleImages || []), ...files];
            const newPreviews = [...prev.vehicleImagePreviews, ...files.map(f => ({ url: URL.createObjectURL(f), name: f.name }))];
            return {
                formData: {
                    ...prev.formData,
                    vehicleImages: newFiles,
                },
                vehicleImagePreviews: newPreviews,
            };
        });
    }
    handleVehicleImagesDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files || []).filter(f => f.type.startsWith('image/'));
        if (!files.length) return;
        this.setState((prev) => {
            const newFiles = [...(prev.formData.vehicleImages || []), ...files];
            const newPreviews = [...prev.vehicleImagePreviews, ...files.map(f => ({ url: URL.createObjectURL(f), name: f.name }))];
            return {
                formData: {
                    ...prev.formData,
                    vehicleImages: newFiles,
                },
                isDragActive: false,
                vehicleImagePreviews: newPreviews,
            };
        });
    }
    handleVehicleImagesDragOver = (e) => {
        e.preventDefault();
        if (!this.state.isDragActive) this.setState({ isDragActive: true });
    }
    handleVehicleImagesDragLeave = () => {
        if (this.state.isDragActive) this.setState({ isDragActive: false });
    }
    handleRemoveVehicleImage = (index) => {
        this.setState((prev) => {
            const files = [...(prev.formData.vehicleImages || [])];
            const previews = [...prev.vehicleImagePreviews];
            files.splice(index, 1);
            const removed = previews.splice(index, 1);
            if (removed[0]?.url) URL.revokeObjectURL(removed[0].url);
            return {
                formData: {
                    ...prev.formData,
                    vehicleImages: files,
                },
                vehicleImagePreviews: previews,
            };
        });
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        const { formData } = this.state;
        const vehicleFormData = new FormData();

        Object.keys(formData).forEach(key => {
            if (key === 'vehicleImages' && Array.isArray(formData[key]) && formData[key].length > 0) {
                // Yeni araç görselleri - File objelerini gönder
                formData[key].forEach(file => {
                    if (file instanceof File) {
                        vehicleFormData.append('vehicleImages[]', file);
                    }
                });
            } else if (Array.isArray(formData[key])) {
                formData[key].forEach(item => {
                    vehicleFormData.append(`${key}[]`, item);
                });
            } else {
                vehicleFormData.append(key, formData[key]);
            }
        });

        console.log('Gönderilen vehicleImages sayısı:', formData.vehicleImages?.length || 0);

        try {
            const response = await apiCall('business/vehicle/add', 'post', vehicleFormData);
            this.setState({ loading: false });

            // Başarılı olursa formu temizle
            if (response.status === 'success') {
                this.setState({
                    vehicleImagePreviews: [],
                    formData: {
                        ...this.state.formData,
                        vehicleImages: []
                    }
                });
            }

            mainHelper.toastMessage(response.status, response.message);
        } catch (e) {
            this.setState({ loading: false });
        }
    }
    render() {
        const { loading, branches, customers, brands, models, selectedBrand, selectedModel, selectedCustomer } = this.state;
        const { userPermissions } = this.props;
        const userHasNewVehiclePermission = userPermissions.includes('new vehicle');
        const formattedOptions = customers.map(option => ({
            value: option.id,
            label: option.name + ' ' + option.surname
        }));

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Yeni Araç Ekle"
                            Breadcrumb={[
                                { name: "Araçlar", navigate: "vehicles" },
                                { name: "Yeni Araç", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <form onSubmit={this.handleSubmit} encType="multipart/form-data">
                                        <div className="body">
                                            <div className="row clearfix">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <small>Araç ekleme ekranı ile müşterilerinizin araçlarını hızlıca sisteme kaydedebilir, servis kaydı oluşturmadan önce tüm araç bilgilerini eksiksiz şekilde yönetebilirsiniz.</small>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <h6>Araç Bilgileri</h6>
                                                    <div className="form-group">
                                                        <Select
                                                            placeholder="Müşteri Seçiniz..."
                                                            options={formattedOptions}
                                                            value={selectedCustomer}
                                                            onChange={this.handleCustomerChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <select name="branch_id" id='branch_id'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Şube Seçiniz</option>
                                                            {branches && (branches.map(branch => (
                                                                <option key={branch.id}
                                                                    value={branch.id}>{branch.name}</option>
                                                            )))}

                                                        </select>
                                                    </div>

                                                    <div className="form-group">
                                                        <input name="plate"
                                                            id="plate"
                                                            className="form-control"
                                                            placeholder="Plaka"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Select
                                                            className="border-danger"
                                                            value={selectedBrand}
                                                            onChange={this.handleBrandChange}
                                                            options={brands}
                                                            placeholder="Marka Seçin"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    borderColor: state.isFocused ? 'red' : 'red',
                                                                    boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                                    '&:hover': { borderColor: 'red' }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <Select
                                                            className="border-danger"
                                                            value={selectedModel}
                                                            onChange={this.handleModelChange}
                                                            options={models}
                                                            placeholder="Model Seçin"
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    borderColor: state.isFocused ? 'red' : 'red',
                                                                    boxShadow: state.isFocused ? '0 0 0 1px red' : 'none',
                                                                    '&:hover': { borderColor: 'red' }
                                                                })
                                                            }}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="year"
                                                            id="year"
                                                            className="form-control"
                                                            placeholder="Model Yılı"
                                                            type="number"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="vehicleData.gen"
                                                            id="gen"
                                                            className="form-control"
                                                            placeholder="Nesil (F30, Megane 4 , Clio 3 vs...)"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <textarea name="details"
                                                            id="details"
                                                            className="form-control"
                                                            placeholder="Araç detayları"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="maintenance_date"
                                                            className="date-placeholder text-cyan">
                                                            Bakım tarihi
                                                        </label>
                                                        <input name="maintenance_date"
                                                            id="maintenance_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="inspection_date"
                                                            className="date-placeholder text-cyan">
                                                            Muayene tarihi
                                                        </label>
                                                        <input name="inspection_date"
                                                            id="inspection_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                    <h6>&nbsp;</h6>
                                                    <div className="form-group">
                                                        <select name="gear_type" id='gear_type'
                                                            className="form-control"
                                                            onChange={this.handleChange}>
                                                            <option value="">Vites Tipi Seçiniz</option>
                                                            <option value="otomatik">Otomatik</option>
                                                            <option value="manuel">Manuel</option>

                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="engine_no"
                                                            id="engine_no"
                                                            className="form-control"
                                                            placeholder="Motor No"
                                                            type="number"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="engine_size"
                                                            id="engine_size"
                                                            className="form-control"
                                                            placeholder="Motor Hacmi"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="km"
                                                            id="km"
                                                            className="form-control"
                                                            placeholder="Km"
                                                            type="number"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="chassis_no"
                                                            id="chassis_no"
                                                            className="form-control"
                                                            placeholder="Şase No"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="package_name"
                                                            id="package_name"
                                                            className="form-control"
                                                            placeholder="Paket Adı"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <input name="key_no"
                                                            id="key_no"
                                                            className="form-control"
                                                            placeholder="Anahtar No"
                                                            type="text"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="next_maintenance_date"
                                                            className="date-placeholder text-cyan">
                                                            Sonraki bakım tarihi
                                                        </label>
                                                        <input name="next_maintenance_date"
                                                            id="next_maintenance_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="next_inspection_date"
                                                            className="date-placeholder text-cyan">
                                                            Sonraki muayene tarihi
                                                        </label>
                                                        <input name="next_inspection_date"
                                                            id="next_inspection_date"
                                                            className="form-control"
                                                            type="date"
                                                            onChange={this.handleChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row clearfix">
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <label className="font-weight-bold text-cyan">Araç Görselleri</label>
                                                        <div
                                                            onDragOver={this.handleVehicleImagesDragOver}
                                                            onDragLeave={this.handleVehicleImagesDragLeave}
                                                            onDrop={this.handleVehicleImagesDrop}
                                                            onClick={() =>
                                                                this.vehicleImagesInputRef.current && this.vehicleImagesInputRef.current.click()
                                                            }
                                                            className="text-center"
                                                            style={{
                                                                border: '2px dashed #ced4da',
                                                                borderRadius: 6,
                                                                padding: 16,
                                                                cursor: 'pointer',
                                                                backgroundColor: this.state.isDragActive ? '#f8f9fa' : 'transparent',
                                                                textAlign: 'center',
                                                            }}
                                                        >
                                                            <div>Dosyaları buraya sürükleyip bırakın ya da tıklayıp seçin</div>
                                                            <small className="text-muted">
                                                                Sadece görsel dosyalar (birden fazla seçebilirsiniz)
                                                            </small>
                                                            <input
                                                                ref={this.vehicleImagesInputRef}
                                                                type="file"
                                                                accept="image/*"
                                                                multiple
                                                                style={{ display: 'none' }}
                                                                onChange={this.handleVehicleImagesSelect}
                                                            />
                                                        </div>

                                                        {this.state.vehicleImagePreviews && this.state.vehicleImagePreviews.length > 0 && (
                                                            <div className="d-flex flex-wrap mt-2" style={{ gap: 10 }}>
                                                                {this.state.vehicleImagePreviews.map((p, idx) => (
                                                                    <div key={idx} style={{ position: 'relative' }}>
                                                                        <img
                                                                            src={p.url}
                                                                            alt={p.name}
                                                                            style={{
                                                                                width: 90,
                                                                                height: 90,
                                                                                objectFit: 'cover',
                                                                                borderRadius: 6,
                                                                                border: '1px solid #e9ecef',
                                                                            }}
                                                                        />
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-danger btn-sm"
                                                                            style={{ position: 'absolute', top: -10, right: -10 }}
                                                                            onClick={() => this.handleRemoveVehicleImage(idx)}
                                                                        >
                                                                            <i className="icon-trash" />
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="body">
                                                <div className="row clearfix justify-content-center">
                                                    <div className="col-lg-6 col-md-12">
                                                        {loading ? (
                                                            <button className="btn btn-outline-primary btn-block"
                                                                disabled={true}
                                                                style={{ textAlign: "-webkit-center" }}>
                                                                Lütfen Bekleyin...<ReactLoading type="spin"
                                                                    width={'24px'}
                                                                    height={'24px'}
                                                                    color="#268bd2"></ReactLoading>
                                                            </button>
                                                        ) :
                                                            <button disabled={!userHasNewVehiclePermission}
                                                                className="btn btn-outline-primary btn-block"
                                                                type="submit">
                                                                Güncelle
                                                            </button>}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ ioTReducer }) => ({
    isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(VehicleAdd)));
